import {computed, Ref} from "vue";
import useExperimentalFeatures from "@/core/composables/experimental-features/useExperimentalFeatures";
import {cacheKey} from "@/lib/cache";
import useSwr from "@/core/composables/swr/useSwr";
import {contestApi} from "@/container";

const useContests = (status: Ref<'ended' | 'upcoming' | null>) => {
    const {enabled} = useExperimentalFeatures();

    const swrKey = computed(() => {
        const params = {status: status.value};

        if (enabled.value) {
            params['experimental'] = true;
        }

        return cacheKey('contests', params);
    });

    return useSwr(
        () => swrKey.value,
        () => contestApi().index({
            status: status.value,
            ...enabled.value ? {experimental: true} : {}
        })
    );
};

export default useContests;
